<template>
   <s-modal 
        :open="open"
        title="Ajouter des invités"
        :close="true"
        @close="$emit('close')"
        >
        <div class="tabs is-boxed">
            <ul>
                <li :class="tab==0 ? 'is-active' : ''" v-on:click="tab=0">
                <a>
                    <span class="icon is-small"><i class="fas fa-user" aria-hidden="true"></i></span>
                    <span>Invités</span>
                </a>
                </li>
                
            </ul>
            </div>
        <div v-if="tab==0" class="tabContent">
            <label class="title is-5">Nombre d'invités anonymes à ajouter :</label>
            <br/> <br/>
            <input v-model="nbJoueursAnonymes" class="input is-rounded is-primary is-medium" type="number" 
                    style="width:100px"/>
            &nbsp;
            <s-button theme="is-success" icon="plus" label="Ajouter" @onclick="AddJoueursAnonymes"/>
        </div>
        <div v-if="tab==1" class="tabContent">
            Rechercher un autre club :
        </div>
        <div v-if="tab==2" class="tabContent">

        </div>
    </s-modal>
</template>
<style scoped>
    .tabContent {
        height: 400px;
    }
</style>
<script>
export default {
    props: ["open"],
    data() {
        return {
            tab: 0,
            nbJoueursAnonymes: 1
        }
    },
    methods: {
        AddJoueursAnonymes() {
           
            this.$emit("addAnonymes", this.nbJoueursAnonymes);
            
        }
    }
}
</script>